import React from "react";
import {Select, Table, Tooltip} from "antd";
import {useEffect, useState} from "react";
import {getRequest} from "../../util/APIUtils";
import {getCurrencyTypeSuffix, showAxiosError} from "../../util/Helpers";
import {VatType} from "../../util/Enums";

function HotelCampaignForm(props) {

    const [cities, setCities] = useState();
    const [cityOptions, setCityOptions] = useState([]);
    const [content, setContent] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (!cities) {
            getCitiesApi();
        }
    }, []);

    const getCitiesApi = () => {
        getRequest("/form/citiesNameUsingHotelForm").then((response) => {
            if (response && response.data) {
                setCities(response.data);
                prepareCitySelectOptions(response.data);
            }
        }).catch((error) => {
            showAxiosError(error.response)
        })
    }

    const prepareCitySelectOptions = (cities) => {
        let cityOptions = [];
        cities.map(c => {
            cityOptions.push({value: c.recordId, label: c.name});
        });
        setCityOptions(cityOptions);
    }

    const onSelectChange = (value) => {
        if (!value) {
            setContent([]);
            setTotal(0);
        } else {
            getRequest("/form/getHotels/" + value).then(response => {
                if (response && response.data) {
                    setContent(response.data)
                    setTotal(response.data.length);
                }
            }).catch(error => {
                showAxiosError(error);
            })
        }
    }

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            width: '1%',
            render: (text, record, index) => (
                <label>{index + 1}</label>
            )
        },
        {
            title: 'Otel Adı',
            dataIndex: 'hotelName',
            key: 'hotelName',
            width: '20%',
        },
        {
            title: 'Geçerlilik Tarihi',
            dataIndex: 'startDateAndEndDate',
            key: 'startDateAndEndDate',
            width: '3%',
        },
        {
            title: 'Pansiyon Tipi',
            dataIndex: 'hotelType',
            key: 'hotelType',
            width: '3%',
            // render: (text, record, index) => {
            //     // if (text !== null && text.length > 15) {
            //     console.log(record);
            //         return <Tooltip placement="bottom" title={text}>
            //             <label>{text}</label>
            //         </Tooltip>
            //     // } else {
            //     //     return <label>{text}</label>
            //     // }
            // }
        },
        {
            title: 'Tek Kişilik Oda Fiyatı',
            dataIndex: 'singleRoomPrice',
            key: 'singleRoomPrice',
            width: '17%',
            render: (text, record, index) => {
                if (text === null) {
                    return (<label>-</label>)
                } else {
                    return (<label>{text + " " + getCurrencyTypeSuffix(record.currency)}</label>);
                }
            }
        },
        {
            title: 'İki Kişilik Oda Fiyatı',
            dataIndex: 'doubleRoomPrice',
            key: 'doubleRoomPrice',
            width: '17%',
            render: (text, record, index) => {
                if (text === null) {
                    return (<label>-</label>)
                } else {
                    return (<label>{text + " " + getCurrencyTypeSuffix(record.currency)}</label>);
                }
            }
        },
        {
            title: 'Üç Kişilik Oda Fiyatı',
            dataIndex: 'tripleRoomPrice',
            key: 'tripleRoomPrice',
            width: '17%',
            render: (text, record, index) => {
                if (text === null) {
                    return (<label>-</label>)
                } else {
                    return (<label>{text + " " + getCurrencyTypeSuffix(record.currency)}</label>);
                }
            }
        },
        {
            title: 'Kdv',
            dataIndex: 'vat',
            key: 'vat',
            width: '4%',
            render: (text, record, index) => {
                if (VatType.INCLUDED === text) {
                    return (<label>Dahil</label>)
                } else if (VatType.EXCLUDED === text) {
                    return (<label>Hariç</label>)
                } else {
                    return (<label/>)
                }
            }
        },
        {
            title: 'Not',
            dataIndex: 'note',
            key: 'note',
            width: '22%'
        }
    ];

    return (
        <div>
            <div className="full-w align-left d-flex flex-row">
                {cities &&
                    <label className="col-xs-6">Şehir Seçiniz</label>
                }
                {cities &&
                    <Select className="col-xs-6"
                            style={{width: "150px", marginLeft: "10px"}}
                            allowClear
                            options={cityOptions}
                            onChange={onSelectChange}
                            showSearch
                            placeholder="Şehir seçiniz"
                            filterOption={(input, option) => option.label.toLocaleLowerCase("tr").includes(input.toLocaleLowerCase("tr"))}
                    />
                }
            </div>
            {content.length > 0 &&
                <div>
                    <Table dataSource={content}
                           rowKey={record => record.recordId}
                           size="large"
                           columns={columns}
                           pagination={{
                               total,
                               showTotal: (total) => `Toplam ${total} kayıt`
                           }}/>
                </div>
            }
        </div>
    )
}

export default HotelCampaignForm;


// WEBPACK FOOTER //
// ./src/component/CampaignForm/HotelCampaignForm.js